import React from 'react';
import WelcomeSection from './dashboard/WelcomeSection';
import BrandsSection from './dashboard/BrandsSection';
// import AnalyticsSection from './dashboard/AnalyticsSection'; // Removed - analytics now shown in brand cards only
import AddProjectModal from './dashboard/AddProjectModal';
import NewAffiliatesLive from './dashboard/NewAffiliatesLive';
import PaidTrafficFinder from './dashboard/PaidTrafficFinder';

const MainContentModular = ({ recentlyContactedAffiliates, newAffiliatesByCountry }) => {
  return (
    <main
      className="p-4 min-h-screen bg-gray-100 dark:bg-slate-950 transition-colors duration-300"
      style={{
        fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
      }}
    >
      <WelcomeSection />
      <AddProjectModal />
      <NewAffiliatesLive />
      {/* Renders nothing unless something was found in the last 24 hours. */}
      <PaidTrafficFinder />
      <BrandsSection />
      {/* <AnalyticsSection
        newAffiliatesByCountry={newAffiliatesByCountry}
      /> */}

    </main>
  );
};

export default MainContentModular;